import { render, staticRenderFns } from "./index.vue?vue&type=template&id=308a00b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/components/pages/whitelists/main/styles/scoped.scss?vue&type=style&index=0&id=308a00b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a00b8",
  null
  
)

export default component.exports